import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { PatientInfo } from '../components';
import { PatientProfileTO } from '../../../../lib';

interface DeIndentifiedPatientHeaderProps {
  patientProfile: PatientProfileTO;
  toggleFavourite: () => void;
}
const DeIndentifiedPatientHeader = ({
  patientProfile,
  toggleFavourite,
}: DeIndentifiedPatientHeaderProps) => {
  return (
    <Row>
      <Col lg="12">
        <PatientInfo
          profile={patientProfile}
          toggleFavourite={toggleFavourite}
          hasDeidentifiedPermission
        />
      </Col>
    </Row>
  );
};

export default DeIndentifiedPatientHeader;
